import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20c10cac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment-tabs" }
const _hoisted_2 = { class: "text-area" }
const _hoisted_3 = { class: "field-error" }
const _hoisted_4 = {
  key: 0,
  class: "invoice-number"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "Fakturanr:", -1))

import { computed, ref } from "vue";
import Textarea from "../Forms/Textarea.vue";


import { defineComponent } from "vue";

const __default__ = defineComponent({});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Comments',
  props: {
    orderComment: {},
    invoiceComment: {},
    orderError: {},
    invoiceError: {},
    customer_note: {},
    invoiceId: {}
  },
  emits: [
  "update:orderComment",
  "update:invoiceComment",
  "inputs",
],
  setup(__props: any, { emit }) {

const props = __props;





const orderComment = computed({
  get: () => {
    return props.orderComment;
  },
  set: (v) => {
    emit("update:orderComment", v);
  },
});

const invoiceComment = computed({
  get: () => {
    return props.invoiceComment;
  },
  set: (v) => {
    emit("update:invoiceComment", v);
  },
});

const selectedTab = ref("order");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass(["comment-tabs__tab label", { active: selectedTab.value === 'order' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedTab.value = 'order'))
      }, " Ordrekommentar ", 2),
      _createElementVNode("button", {
        class: _normalizeClass(["comment-tabs__tab label", { active: selectedTab.value === 'invoice' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedTab.value = 'invoice'))
      }, " Fakturakommentar ", 2)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (selectedTab.value === 'order')
        ? (_openBlock(), _createBlock(Textarea, {
            key: 0,
            onInput: _cache[2] || (_cache[2] = ($event: any) => (emit('inputs'))),
            modelValue: orderComment.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((orderComment).value = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (selectedTab.value === 'invoice')
        ? (_openBlock(), _createBlock(Textarea, {
            key: 1,
            onInput: _cache[4] || (_cache[4] = ($event: any) => (emit('inputs'))),
            modelValue: invoiceComment.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((invoiceComment).value = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_3, [
        (selectedTab.value === 'order')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.orderError), 1)
            ], 64))
          : _createCommentVNode("", true),
        (selectedTab.value === 'invoice')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.invoiceError), 1)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    (selectedTab.value === 'invoice' && _ctx.invoiceId)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.invoiceId), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})